<template>
  <div id="headerbar">
      <div class="header_nav">
        <span v-if="is_dialogpage">{{ caname }}&gt;{{ pagename }}&gt;<i>{{ addoredirtname }}</i></span>
         <span v-if="!is_dialogpage">{{ caname }}&gt;<i>{{ pagename }}</i></span>
        
      </div>
  </div>
</template>

<script>
    export default{
        name:"headerbar",
        data(){
            return{
                caname:"",
                pagename:"",
            }
        },
        props:{
            routername:{
                type:String,
                required:true
            },
            is_dialogpage:{
                type:Boolean,
                required:true
            },
            addoredirtname:{
                type:String,
                required:true
            }
        },
        mounted(){
            this.getHeaderNav()
        },
        methods:{
              getHeaderNav(){
                const navname=this.routername
                const routelist=JSON.parse(sessionStorage.getItem("routemenuList"));
                for (let i = 0; i < routelist.length; i++) {
                    if(routelist[i].pageName==navname){
                        this.pagename=routelist[i].menuName
                        this.caname=routelist[i].catoryName
                        return
                    }
                    
                }
            }
        }
    }
</script>
<style scoped>
#headerbar{
    width: 100%;
    height: 40px;
    float: left; 
    padding:0 50px;
    
   
}
#headerbar .header_nav{
    width: 100%;
    height: 40px;
    float: left;
    border-bottom: 1px solid #e0dfdf;
}
#headerbar .header_nav span{
    width: 100%;
    height: 40px;
    line-height: 40px;
    float: left;
    color: #8e8e8e;
    font-size: 16px;
}
#headerbar .header_nav span i{
    font-style: normal;
    color: #343434;
}
</style>